import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function MedjunarodnoJavnoPravo() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Međunarodno javno pravo" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Međunarodno javno pravo</h2>
              <p>
                <strong>Studijski program:</strong> Pravo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Međunarodno javno pravo
              </p>
              <p>
                <strong>Nastavnik:</strong>
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezan
              </p>
              <p>
                <strong>Broj ECTS:</strong> 6
              </p>
              <p>
                <strong>Uslov:</strong> nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Osnovni cilj predmeta Međunarodno javno pravo je upoznavanje
                studenata sa pojmom međunardnog prava njegovim osnovnim
                principima izvorima subjektima međunarodnog prava njihovim
                međusobnim odnosima koje je usled globalizacije i sve prisnijih
                i komplikovanijih među-državnih međunarodnih odnosa neophodno
                kako bi se studenti profesionalno osposobili za buduće izazove
                iz ove oblasti.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Po završetku kursa studenti će biti sposobni: da objasne
                nastanak razvoj međunarodnog javnog prava osnovne izvore i
                načela; da objasne i razlikuju subjekte međunardnog prava kao i
                njihove međusobne odnose; da objasne institute međunardnog prava
                kao i sličnosti i razlike između pojedinih instituta
                međunarodnog i unutrašnjeg prava; da definišu i opišu pojam i
                izvore međunarodnih ljudskih prava i ugovornog prava; da objasne
                pojam i izvore prava mora diplomatskog prava međunarodnog
                humanitarnog prava međunarodnog prava zaštite životne sredine;
                da opišu položaj pojedinca u odnosu na državu i njegova prava
                prema međunarodnom pravu kao i da osposobi studente da
                samostalno i kritički posmatraju međunarodna kretanja i
                dešavanja.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                Pojam razvoj i osnovne karakteristike međunarodnog javnog prava;
                Doktrina međunarodno javnog prava; Odnos unutrašnjeg i
                međunarodnog prava; Izvori međunarodnog prava; Subjekti
                međunarodnog prava; Država; Priznanje države i vlade; Prava i
                dužnosti države; Nadležnost države u međunarodnom pravu;
                Odgovornost države; Sukcesija država; Organi za održavanje
                međunarodnih odnosa; Diplomatsko pravo; Konzularno pravo;
                Multilateralna diplomatija; Granice; Načini sticanja i gubitka
                državne teritorije; Međunarodne službenosti; Međunarode rijeke;
                Pomorska oblast; Vazdušna oblast; Polarna oblast; Kosmičko
                prostranstvo; Pravila međunarodnog ugovornog prava; Međunarodne
                organizacije; Ujedinjene nacije; Regionalne i specijalizovane
                organizacije; Međunarodna ljudska prava; Međunarodno krivično
                pravo; Međunarodni krivični sud; Ljudska prava i slobode i
                Evropski sud za ljudska prava; Međunarodna zaštita životne
                sredine; Sredstva mirnog rješavanja međunarodnih sporova;
                Međunarodno humanitarno pravo; Pravo oružanih sukoba: pojam rata
                ograničenja ratovanja zaštita ratnih zarobljenika ranjenika
                bolesnika
              </p>
              <p>
                <strong>Praktična nastava:</strong> Posjeta međunarodnim
                institucijama. Analiza rada i akata međunarodnih institucija.
                Analiza sudske prakse. Sastavljanje međunarodnih ugovora.
                Posjeta diplomatskim i konzularnim predstavništvima.
              </p>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Osnovni oblici rada na predmetu su: predavanja i vježbe,
                samostalni rad (seminarski rad), terenska nastava, seminari i
                radionice, upoznavanje studenata sa praksom međunarodnih sudova.
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>4P + 2V</td>
                    <td>
                      Pojam, razvoj i osnovne karakteristike međunarodnog javnog
                      prava; Doktrina međunarodno javnog prava
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>4P + 2V</td>
                    <td>
                      Odnos unutrašnjeg i međunarodnog prava; Izvori
                      međunarodnog prava; Subjekti međunarodnog prava
                    </td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>4P + 2V</td>
                    <td>
                      Država; Priznanje države i vlade; Prava i dužnosti države;
                      Nadležnost države u međunarodnom pravu; Odgovornost
                      države; Sukcesija država
                    </td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>4P + 2V</td>
                    <td>
                      Organi za održavanje međunarodnih odnosa; Diplomatsko
                      pravo; Konzularno pravo; Multilateralna diplomatija
                    </td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>4P + 2V</td>
                    <td>
                      Granice; Načini sticanja i gubitka državne teritorije;
                      Međunarodne službenosti; Međunarodne rijeke
                      <br />
                      Praktična nastava: Posjeta diplomatskim i konzularnim
                      predstavništvima
                    </td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td></td>
                    <td>KOLOKVIJUM I</td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>4P + 2V</td>
                    <td>
                      Pomorska oblast; Vazdušna oblast; Polarna oblast; Kosmičko
                      prostranstvo
                    </td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>4P + 2V</td>
                    <td>
                      Pravila međunarodnog ugovornog prava
                      <br />
                      Praktična nastava: Sastavljanje međunarodnih ugovora
                    </td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>4P + 2V</td>
                    <td>
                      Međunarodne organizacije; Ujedinjene nacije; Regionalne i
                      specijalizovane organizacije
                      <br />
                      Praktična nastava: Posjeta međunarodnim institucijama.
                      Analiza rada i akata međunarodnih institucija
                    </td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>4P + 2V</td>
                    <td>Međunarodna ljudska prava</td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>4P + 2V</td>
                    <td>
                      Međunarodno krivično pravo; Međunarodni krivični sud;
                      Ljudska prava i slobode i Evropski sud za ljudska prava;
                      Međunarodna zaštita životne sredine
                    </td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td></td>
                    <td>KOLOKVIJUM II</td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>4P + 2V</td>
                    <td>Sredstva mirnog rješavanja međunarodnih sporova</td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>4P + 2V</td>
                    <td>Međunarodno humanitarno pravo</td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>4P + 2V</td>
                    <td>
                      Pravo oružanih sukoba: pojam rata ograničenja ratovanja
                      zaštita ratnih zarobljenika ranjenika bolesnika
                      <br />
                      Praktična nastava: Analiza sudske prakse. Analiza ratnih
                      sukoba
                    </td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td></td>
                    <td>Sveobuhvatni ispit</td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td></td>
                    <td>Ovjera semestra i upis ocjena</td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td></td>
                    <td>Popravni ispitni rok</td>
                  </tr>
                </tbody>
              </table>
              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 6 č / 4.3h</td>
                            <td>Ukupno: 120 č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 4 č / 3.00h</td>
                            <td>Nastava + završni ispit: 90 č</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 2 č / 1.3h</td>
                            <td>Priprema i ovjera semestra: 9 č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 21 č</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default MedjunarodnoJavnoPravo;
